import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Maximize2, Loader2, UserCheck, UserX } from 'lucide-react';
import { apiRequest } from '../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

export default function TeamOverviewWidget({ expandable, expandPath }) {
  const navigate = useNavigate();
  const [team, setTeam] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeam();
  }, []);

  const fetchTeam = async () => {
    try {
      const data = await apiRequest('/users/my-team');
      setTeam(data);
    } catch (error) {
      console.error('Failed to fetch team');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card data-testid="team-overview-widget">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Users className="h-5 w-5 text-cyan-500" />
            <CardTitle className="text-lg">Team Overview</CardTitle>
          </div>
          {expandable && (
            <Button variant="ghost" size="icon" onClick={() => navigate(expandPath || '/admin/user-management')} className="h-8 w-8">
              <Maximize2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex justify-center py-4">
            <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
          </div>
        ) : !team ? (
          <div className="text-center py-4 text-slate-400">
            <Users className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">No team data</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            <div className="p-3 bg-slate-50 rounded-lg text-center">
              <p className="text-2xl font-bold text-slate-900">{team.total || 0}</p>
              <p className="text-xs text-slate-500">Total Staff</p>
            </div>
            <div className="p-3 bg-green-50 rounded-lg text-center">
              <p className="text-2xl font-bold text-green-600">{team.on_shift || 0}</p>
              <p className="text-xs text-green-700">On Shift</p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
